import React from 'react';
import { objectOf, string, shape } from 'prop-types';
import { Box } from '@mui/material';

import { Secret } from './components';

import InputField from '../InputField';
import CopyButton from '../CopyButton';

import staticText from '../../localization/Application/Configuration/configuration';

const Credentials = ({
  applications,
  selectedApplication,
}) => {
  const application = applications[selectedApplication];
  const {
    id: clientId,
    name,
  } = application;

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <InputField
        label={staticText.oauth.clientId}
        type="text"
        inputName="clientId"
        inputValues={clientId}
        inputDisabled
        showActionsOnHover
        actions={(
          <CopyButton content={clientId} />
        )}
      />
      <Secret
        applicationId={clientId}
        applicationName={name}
      />
    </Box>
  );
};

Credentials.propTypes = {
  applications: objectOf(shape({
    name: string.isRequired,
    id: string.isRequired,
  })).isRequired,
  selectedApplication: string.isRequired,
};

export default Credentials;
